/**
 * MyBricks Opensource
 * https://mybricks.world
 * This source code is licensed under the MIT license.
 *
 * CheMingjun @2019
 * mybricks@126.com
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var setOutputSchema = function (_a) {
    var data = _a.data, input = _a.input, output = _a.output, _b = _a.schema, schema = _b === void 0 ? null : _b;
    var inputSchema = schema || input.get('inputValue').schema;
    if (data.merge && inputSchema && inputSchema.type === 'object') {
        output.get('rtn').setSchema(__assign(__assign({}, inputSchema), { properties: __assign(__assign({}, inputSchema.properties), { userId: { type: 'number' } }) }));
    }
    else {
        output.get('rtn').setSchema({ type: 'object', properties: { userId: { type: 'number' } } });
    }
};
export default {
    '@inputConnected': function (_a, _b) {
        var data = _a.data, output = _a.output, input = _a.input;
        var schema = _b.schema;
        setOutputSchema({ data: data, input: input, output: output, schema: schema });
    },
    ':root': [
        {
            title: '合并输入',
            type: 'switch',
            desc: '当输入值为对象时合并输入值',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.merge;
                },
                set: function (_a, use) {
                    var data = _a.data, input = _a.input, outputs = _a.outputs;
                    data.merge = use;
                    setOutputSchema({ data: data, input: input, output: outputs });
                }
            }
        }
    ]
};
